import { API_ROOT } from 'environment';

angular
.module('app.views')
.controller('OrderFormController', function($scope, $modalInstance, $http, toaster, Order, order) {
  $scope.order = order;

  $scope.countries = [];
  $http.get(`${API_ROOT}/checkout/countries`).then((response) => {
    $scope.countries = response.data;
  });

  $scope.states = [];
  $http.get(`${API_ROOT}/checkout/states`).then((response) => {
    $scope.states = response.data;
  });

  // Orders can be moved between the following statuses
  $scope.orderStatuses = [
    {label: 'Backordered', value: 'on_hold'},
    {label: 'Awaiting Payment', value: 'awaiting_payment'},
    {label: 'Awaiting Shipment', value: 'awaiting_shipment'},
    {label: 'Cancelled', value: 'cancelled'},
  ];

  $scope.save = () => {
    $scope.isSaving = true;
    Order.update({id: $scope.order.id}, {
      ship_to: $scope.order.ship_to,
      status: $scope.order.status,
      internal_notes: $scope.order.internal_notes,
      email: $scope.order.email,
      prioritized: $scope.order.prioritized,
      replacement: $scope.order.replacement,
    }, () => {
      $modalInstance.close();
      $scope.isSaving = false;
    }, (err) => {
      toaster.pop({
        type: 'error',
        body: `Error saving order: ${err}`,
        timeout: 2000
      });
      $scope.isSaving = false;
    });
  }

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/order/order_form_controller.js